import type { CasinoSharedRootState } from '../../ducks/types';
import { REDUCER_NAME } from './constants';

export const currentGameSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME]?.currentGame;
export const gameLoaderResponseSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].gameLoaderResponse;
export const gameLoaderRequestPendingSelector = (state: CasinoSharedRootState) =>
	state[REDUCER_NAME].gameLoaderRequestPending;
export const statusSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].status;
export const hydratedSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].hydrated;
export const loadAsSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].loadAs;
export const gameModeSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].gameMode;
export const errorCodeSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].errorCode;
export const errorDescriptionSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].errorDescription;
export const cleanUpListenersSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].cleanUpListeners;
